export const APP_ENV: string = window.env.APP_ENV;

export const isDevelopment: boolean = ['local', 'stage'].includes(APP_ENV);
